export default __webpack_public_path__ + "static/media/etanorm.1760744e.png";